import type { StartExaminationResponse } from 'src/types/examination';

import { useState, useCallback } from 'react';

import { startExamination } from 'src/actions/examination';

interface StartExaminationParams {
  examinationId: number;
  code?: string;
}

interface UseExaminationStartReturn {
  startExam: (params: StartExaminationParams) => Promise<StartExaminationResponse>;
  isLoading: boolean;
  error: Error | null;
  reset: () => void;
}

// @todo: use react query instead of sw
export function useExaminationStart(): UseExaminationStartReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const reset = useCallback(() => {
    setError(null);
    setIsLoading(false);
  }, []);

  const startExam = useCallback(async ({ examinationId, code }: StartExaminationParams) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await startExamination(examinationId, code);
      return response;
    } catch (err) {
      const errorObj = err instanceof Error ? err : new Error('Failed to start examination');
      setError(errorObj);
      throw errorObj;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    startExam,
    isLoading,
    error,
    reset,
  };
}
